import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {VoipPeerFilterService} from '../../../../../network/utils/filters/voip-peers/voip-peer-filter.service';

@Injectable({
  providedIn: 'root'
})
export class VoipPeerApiService {

  constructor(private http: HttpClient) {
  }

  readonly voipPeerUrl: string = 'topology/voippeer';

  public getVoipPeersForMap(params: any = {}): Promise<any> {
    return this.http.get(this.voipPeerUrl)
      .pipe(
        map((voipPeers: any) => {
          return this.filterVoipPeers(voipPeers, params);
        })
      ).toPromise();
  }

  public getVoipPeersForMapNew(params: any = {}, allVoipPeers) {
    return this.filterVoipPeers(allVoipPeers, params);
  }

  public getVoipPeers(params: any = {}): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.voipPeerUrl, params);
    return this.http.get(url).toPromise();
  }

  public getVoipPeer(id: number): Promise<any> {
    return this.http.get(`${this.voipPeerUrl}/${id}`).toPromise();
  }

  public addVoipPeer(voipPeer: any): Promise<any> {
    return this.http.post(this.voipPeerUrl, voipPeer).toPromise();
  }

  public editVoipPeer(voipPeer: any, id: number): Promise<any> {
    const url = `${this.voipPeerUrl}/${id}`;
    return this.http.put(url, voipPeer).toPromise();
  }

  public deleteVoipPeer(id): Promise<any> {
    const url = `${this.voipPeerUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  public deleteVoipPeers(ids): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.voipPeerUrl, {filter: {id: {value: ids, operator: '='}}});
    return this.http.delete(url).toPromise();
  }

  public moveVoipPeers(voipPeers: any): Promise<any> {
    const url = `${this.voipPeerUrl}/location`;
    return this.http.put(url, voipPeers).toPromise();
  }

  private filterVoipPeers(nodes, params) {
    return (params && params.mapFilter) ?
      VoipPeerFilterService.mapFilter(nodes, params.searchObject) : nodes;
  }

}
